import BreadCrumb from "../../../../components/breadcrumb";
import { complaints } from "../../../../data/constants";
import Header from "../../../../components/DashboardNavigation/header";
import Sidebar from "../../../../components/DashboardNavigation/sidebar";
import { ComplaintsData } from "../../../../components/tables/complaints-tables/complaint";
import { useEffect, useState } from "react";
import { getAllMessages } from "../../../../API/Contact/contactService";
import { ComplaintsType } from "../../../../data/types";

const breadcrumbItems = [
  { title: "Messages", link: "/admin-dashboard/messages" },
];
export default function Complaints() {
  const [complaints, setComplaints] = useState<ComplaintsType[]>([]);
  const fetchData = async () => {
    const response = await getAllMessages();
    setComplaints(response?.complaints);
  };
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <Header />
      <div className="flex h-screen overflow-hidden">
        <Sidebar />
        <div className="flex-1 p-4 pt-6 space-y-4 md:p-8">
          <BreadCrumb items={breadcrumbItems} />
          <ComplaintsData data={complaints} />
        </div>
      </div>
    </>
  );
}
